// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Belt_SortArray from "../../../../node_modules/rescript/lib/es6/belt_SortArray.js";
import * as UseApi$Showside from "../hook/UseApi.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as StoreId$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/Store/StoreId.bs.js";
import * as Accordion$Showside from "./Accordion.bs.js";
import * as PDPSelect$Showside from "./PDPSelect.bs.js";
import * as PDPSelectTypes$Showside from "./PDPSelectTypes.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function MetafieldDrivenColorPicker$Picker(Props) {
  var matchHost = Props.matchHost;
  var productsMetafieldKey = Props.productsMetafieldKey;
  var getCustomSwatch = Props.getCustomSwatch;
  var getLabel = Props.getLabel;
  var labelPrefixOpt = Props.labelPrefix;
  var inline = Props.inline;
  var product = Props.product;
  var labelPrefix = labelPrefixOpt !== undefined ? labelPrefixOpt : "";
  var match = EntrypointContext$Showside.use(undefined);
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var match$2 = match$1.config;
  var match$3 = RouterProvider$Showside.useRouter(undefined);
  var goTo = match$3.goTo;
  var route = match$3.route;
  var isMatch = Belt_Option.mapWithDefault(product.link, false, function (link) {
    return link.includes(matchHost);
  });
  var match$4 = Js_dict.get(product.metadata, productsMetafieldKey);
  var productIds = match$4 !== undefined ? typeof match$4 === "number" ? [] : match$4.TAG === /* ListProductReference */27 ? isMatch ? Belt_SortArray.stableSortBy(Belt_Array.map(match$4._0, StoreId$ApiTypes.ProductId.toString), function (a, b) {
    return a.localeCompare(b) | 0;
  }) : [] : [] : [];
  var label = Belt_Option.flatMap(getLabel, function (fn) {
    return Curry._1(fn, product);
  });
  var match$5 = UseApi$Showside.useProductsById(match$2.transitiveStoreId, productIds, match$2.settings.hideOutOfStock, isMatch, "", match.smartnavApiHost, match.market, undefined);
  var products = match$5.products;
  if (products === undefined) {
    return null;
  }
  if (products.length === 0) {
    return null;
  }
  var tmp = {
    options: Belt_Array.map(products, function (product) {
      var swatch = Belt_Option.flatMap(getCustomSwatch, function (fn) {
        return Curry._1(fn, product);
      });
      return PDPSelectTypes$Showside.makeOption(Belt_Option.getWithDefault(Belt_Option.flatMap(getLabel, function (fn) {
        return Curry._1(fn, product);
      }), product.name), "metafield-driven-color", swatch !== undefined ? {
        TAG: /* ColorSwatch */1,
        _0: swatch
      } : {
        TAG: /* ImageSwatch */0,
        _0: Product$Showside.getDisplaySwatchImage(product, product.firstVariant)
      }, !Product$Showside.isInStock(product), false, product.id, product.name, product.id);
    }),
    kind: /* SwatchButton */1,
    value: product.id,
    onChange: function (value) {
      if (typeof route === "number") {
        return;
      }
      switch (route.TAG | 0) {
        case /* PDP */2:
          var rest = route._0;
          return Curry._3(goTo, undefined, undefined, {
            TAG: /* PDP */2,
            _0: {
              categoryId: rest.categoryId,
              productCategoryId: rest.productCategoryId,
              productId: Belt_Option.getWithDefault(value, rest.productId),
              variantId: undefined,
              zoomedPhotoIndex: rest.zoomedPhotoIndex
            }
          });
        case /* QuickView */3:
          var rest$1 = route._0;
          return Curry._3(goTo, undefined, undefined, {
            TAG: /* QuickView */3,
            _0: {
              mediaId: rest$1.mediaId,
              mediaParentId: rest$1.mediaParentId,
              albumId: rest$1.albumId,
              productId: value,
              relatedMediaProductIds: rest$1.relatedMediaProductIds,
              relatedMediaCategoryId: rest$1.relatedMediaCategoryId,
              variantId: undefined,
              panelClosed: rest$1.panelClosed,
              zoomedPhotoIndex: rest$1.zoomedPhotoIndex,
              time: rest$1.time
            }
          });
        default:
          return;
      }
    }
  };
  var tmp$1 = inline ? 1 : undefined;
  if (tmp$1 !== undefined) {
    tmp.truncateAt = tmp$1;
  }
  return React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make([inline ? "mr-6" : "mt-6 mb-6"]))
  }, React.createElement(Accordion$Showside.Header.make, {
    active: product.id,
    id: product.id,
    className: CSS$Showside.prefix("pb-2"),
    children: null
  }, labelPrefix, label !== undefined ? React.createElement(React.Fragment, undefined, ": ", React.createElement("div", {
    className: CSS$Showside.prefix("inline text-secondary font-bold")
  }, label)) : null), React.createElement(PDPSelect$Showside.make, tmp));
}
MetafieldDrivenColorPicker$Picker.displayName = "MetafieldDrivenColorPicker.Picker";
var Picker = {
  make: MetafieldDrivenColorPicker$Picker
};
function MetafieldDrivenColorPicker(Props) {
  var product = Props.product;
  var inlineOpt = Props.inline;
  var inline = inlineOpt !== undefined ? inlineOpt : false;
  return React.createElement(React.Fragment, undefined, React.createElement(MetafieldDrivenColorPicker$Picker, {
    matchHost: "hyperiontiles.co.uk",
    productsMetafieldKey: "custom::sibling_products",
    getLabel: function (product) {
      return product.name;
    },
    labelPrefix: "Options Available",
    inline: inline,
    product: product
  }), React.createElement(MetafieldDrivenColorPicker$Picker, {
    matchHost: "pratapsons",
    productsMetafieldKey: "custom::variation_products",
    getLabel: function (product) {
      return Belt_Option.map(Js_dict.get(product.metadata, "custom::variation_value"), function (metafield) {
        if (typeof metafield === "number" || metafield.TAG !== /* SingleLineTextField */1) {
          return "";
        } else {
          return metafield._0;
        }
      });
    },
    labelPrefix: "Color",
    inline: inline,
    product: product
  }), React.createElement(MetafieldDrivenColorPicker$Picker, {
    matchHost: "saadaa.in",
    productsMetafieldKey: "custom::product_variants",
    getCustomSwatch: function (product) {
      return Belt_Option.map(Js_dict.get(product.metadata, "custom::product_variant_value"), function (metafield) {
        if (typeof metafield === "number" || metafield.TAG !== /* SingleLineTextField */1) {
          return "";
        } else {
          return metafield._0;
        }
      });
    },
    getLabel: function (product) {
      return Belt_Option.map(Js_dict.get(product.metadata, "custom::product_variant_name"), function (metafield) {
        if (typeof metafield === "number" || metafield.TAG !== /* SingleLineTextField */1) {
          return "";
        } else {
          return metafield._0;
        }
      });
    },
    labelPrefix: "Color",
    inline: inline,
    product: product
  }), React.createElement(MetafieldDrivenColorPicker$Picker, {
    matchHost: "pantproject.com",
    productsMetafieldKey: "custom::color_variants",
    getCustomSwatch: function (product) {
      return Belt_Option.map(Js_dict.get(product.metadata, "custom::color_hex_code"), function (metafield) {
        if (typeof metafield === "number" || metafield.TAG !== /* SingleLineTextField */1) {
          return "";
        } else {
          return metafield._0;
        }
      });
    },
    getLabel: function (product) {
      return product.name;
    },
    labelPrefix: "Color",
    inline: inline,
    product: product
  }));
}
MetafieldDrivenColorPicker.displayName = "MetafieldDrivenColorPicker";
var make = MetafieldDrivenColorPicker;
export { Picker, make };
/* react Not a pure module */